<template>
  <AppCard design="new" class="refund-history">
    <details><summary>Refund history · {{ events.length }}</summary>
    <ol class="refund-timeline">
      <li v-for="event in events" :key="event.id" class="refund-timeline__event">
        <strong class="refund-timeline__title">{{ eventLabel(event) }}</strong>
        <div class="refund-timeline__meta">{{ event.actor_name || 'System' }}<span aria-hidden="true"> · </span><time :datetime="event.created_at">{{ dateLabel(event.created_at) }}</time></div>
        <p v-if="event.data.note">{{ event.data.note }}</p>
        <dl v-if="event.data.reported_amount" class="refund-timeline__amounts"><div><dt>Requested</dt><dd>{{ money(event.data.reported_amount, currency) }}</dd></div><div><dt>Paid</dt><dd>{{ money(event.data.verified_amount, currency) }}</dd></div></dl>
        <p v-if="event.action === 'late_payment'">Payment received: {{ money(event.data.amount, currency) }}</p>
        <RefundDocumentLink v-if="event.data.evidence_url" :href="event.data.evidence_url" label="Invoice / reference" compact />
      </li>
    </ol>
    </details>
  </AppCard>
</template>
<script>
import AppCard from '@/components/AppCard'
import RefundDocumentLink from './RefundDocumentLink'
import { money, dateLabel } from './format'
export default {
  name: 'RefundHistory',
  components: { AppCard, RefundDocumentLink },
  props: { events: { type: Array, default: () => [] }, currency: { type: String, default: 'USD' } },
  methods: {
    money,
    dateLabel,
    eventLabel(event) {
      if (event.data.workflow === 'story_invoice' && event.action === 'report') return 'Story invoice submitted / updated'
      if (event.data.workflow === 'story_invoice' && event.action === 'verify') return 'Payment confirmed by General manager'
      const action = event.action
      return { 'created': 'Refund created', 'report': 'Manager reported a refund', 'verify': 'Finance verified the refund', 'not-required': 'Closed without refund', 'return-to-manager': 'Returned to manager', 'reopen': 'Reopened', 'late_payment': 'Payment received after cancellation', 'assign': 'Manager reassigned', 'reminder_sent': 'Action reminder sent' }[action] || action
    }
  }
}
</script>
<style lang="scss" scoped>
.refund-timeline {
  list-style: none; margin: $ui-space-8 0 0; padding: 0;
  &__event { position: relative; padding: 0 0 $ui-space-20 $ui-space-24; margin-left: $ui-space-4; border-left: 1px solid $ui-line-strong; min-width: 0; }
  &__event:last-child { padding-bottom: 0; border-color: transparent; }
  &__event::before { content: ''; position: absolute; left: -5px; top: 5px; width: 9px; height: 9px; background: $ui-blue; border: 2px solid $ui-blue-soft; border-radius: 50%; box-sizing: border-box; }
  &__title { display: block; color: $ui-ink; line-height: 1.5; font-weight: 600; }
  &__meta { color: $ui-muted; font-size: $ui-font-size-metadata; line-height: 1.6; margin-top: $ui-space-4; }
  p { margin: $ui-space-8 0; line-height: 1.5; overflow-wrap: anywhere; white-space: pre-wrap; }
  .refund-document { margin-top: $ui-space-8; }
  &__amounts { display: flex; gap: $ui-space-16; flex-wrap: wrap; margin: $ui-space-8 0 0; }
  &__amounts div { display: flex; gap: $ui-space-8; }
  dt { color: $ui-muted; font-size: $ui-font-size-metadata; }
  dd { margin: 0; font-size: $ui-font-size-metadata; font-weight: 600; }
}
</style>
